export const entries = [
	{
		'id': 'aB-zKTDZjDINyCLqhgdMK',
		'type': 'repository',
		'fakeId': 'aB-zKTDZjDINyCLqhgdMK',
		'parentId': null,
		'createdAt': '2026-02-28T12:33:57.177Z',
		'title': 'Work items',
		'singular': 'Work item',
		'rank': 0,
		'color': '#FFD93D',
		'isBookmarked': true
	},
	{
		'id': '-CPX86SrlnffwRzvpNgOq',
		'type': 'templatePropertyString',
		'fakeId': '-CPX86SrlnffwRzvpNgOq',
		'parentId': 'aB-zKTDZjDINyCLqhgdMK',
		'createdAt': '2026-02-28T12:33:57.576Z',
		'label': 'Do',
		'slug': 'do',
		'required': true,
		'rank': 0
	},
	{
		'id': 'BaqRIjCusvFCahrQXJUWX',
		'type': 'templatePropertyText',
		'fakeId': 'BaqRIjCusvFCahrQXJUWX',
		'parentId': 'aB-zKTDZjDINyCLqhgdMK',
		'createdAt': '2026-04-09T10:59:38.117Z',
		'label': 'Notes',
		'slug': 'additional-notes',
		'required': false,
		'rank': 9
	},
	{
		'id': 'WQsZN24NG0FywPKlpcHU4',
		'type': 'templatePropertyDate',
		'fakeId': 'WQsZN24NG0FywPKlpcHU4',
		'parentId': 'aB-zKTDZjDINyCLqhgdMK',
		'createdAt': '2026-04-03T17:49:53.914Z',
		'label': 'Created at',
		'slug': 'created-at',
		'required': true,
		'rank': 8
	},
	{
		'id': '4CyekONzSuI33jhX4ZNtO',
		'type': 'templatePropertyBelongsTo',
		'fakeId': '4CyekONzSuI33jhX4ZNtO',
		'parentId': 'aB-zKTDZjDINyCLqhgdMK',
		'createdAt': '2026-03-19T13:31:25.021Z',
		'label': 'Type',
		'slug': 'type',
		'targetRepositoryId': '331Xn2Ka-Od7-_68wFuUH',
		'required': true,
		'allowMany': false,
		'rank': 1
	},
	{
		'id': 'n6umKbiRaVdZmeovJhd2A',
		'type': 'templatePropertyBelongsTo',
		'fakeId': 'n6umKbiRaVdZmeovJhd2A',
		'parentId': 'aB-zKTDZjDINyCLqhgdMK',
		'createdAt': '2026-04-26T13:12:57.174Z',
		'label': 'Category',
		'slug': 'category',
		'targetRepositoryId': 'geg-qOCWjoSskQhNU72FS',
		'required': false,
		'allowMany': false,
		'rank': 6
	},
	{
		'id': '331Xn2Ka-Od7-_68wFuUH',
		'type': 'repository',
		'fakeId': '331Xn2Ka-Od7-_68wFuUH',
		'parentId': null,
		'createdAt': '2026-03-19T13:29:50.881Z',
		'title': 'Item types',
		'singular': 'Item type',
		'rank': 1,
		'color': null,
		'isBookmarked': false
	},
	{
		'id': '5tYMZ0xb7g87YKDAlZhcs',
		'type': 'templatePropertyString',
		'fakeId': '5tYMZ0xb7g87YKDAlZhcs',
		'parentId': '331Xn2Ka-Od7-_68wFuUH',
		'createdAt': '2026-03-19T13:29:50.928Z',
		'label': 'Name',
		'slug': 'name',
		'required': false,
		'rank': null
	},
	{
		'id': 'mDkM_1ceVGEmAypsHaIXC',
		'type': 'templatePropertyString',
		'fakeId': 'mDkM_1ceVGEmAypsHaIXC',
		'parentId': '331Xn2Ka-Od7-_68wFuUH',
		'createdAt': '2026-04-02T09:42:44.802Z',
		'label': 'Description',
		'slug': 'description',
		'required': false,
		'rank': null
	},
	{
		'id': '9hhm_4uVcAH6Ee4MTdOPi',
		'type': 'repository',
		'fakeId': '9hhm_4uVcAH6Ee4MTdOPi',
		'parentId': null,
		'createdAt': '2026-02-28T12:33:57.177Z',
		'title': 'Daily journal',
		'singular': 'Journal entry',
		'rank': 3,
		'color': '#6BCB77',
		'isBookmarked': true
	},
	{
		'id': 'kATI9Xf5DINOzNzVqu--e',
		'type': 'templatePropertyString',
		'fakeId': 'kATI9Xf5DINOzNzVqu--e',
		'parentId': '9hhm_4uVcAH6Ee4MTdOPi',
		'createdAt': '2026-03-02T10:53:11.525Z',
		'label': ' Goal',
		'slug': 'goal',
		'required': true,
		'rank': 1
	},
	{
		'id': '5cp907OwvuNteGFgSQ-x1',
		'type': 'templatePropertyText',
		'fakeId': '5cp907OwvuNteGFgSQ-x1',
		'parentId': '9hhm_4uVcAH6Ee4MTdOPi',
		'createdAt': '2026-04-03T11:51:02.601Z',
		'label': 'Notes',
		'slug': 'notes1',
		'required': false,
		'rank': 3
	},
	{
		'id': 'secRcYa1ibIY_9IYlI5lj',
		'type': 'templatePropertyDate',
		'fakeId': 'secRcYa1ibIY_9IYlI5lj',
		'parentId': '9hhm_4uVcAH6Ee4MTdOPi',
		'createdAt': '2026-03-16T16:49:28.342Z',
		'label': 'Day',
		'slug': 'day',
		'required': true,
		'rank': 0
	},
	{
		'id': '8U446QKVEjtPFBeGDMVfu',
		'type': 'templatePropertyBelongsTo',
		'fakeId': '8U446QKVEjtPFBeGDMVfu',
		'parentId': '9hhm_4uVcAH6Ee4MTdOPi',
		'createdAt': '2026-03-02T10:52:16.066Z',
		'label': 'Work items',
		'slug': 'work-items',
		'targetRepositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'required': false,
		'allowMany': true,
		'rank': 2
	},
	{
		'type': 'repositoryEntry',
		'parentId': '331Xn2Ka-Od7-_68wFuUH',
		'repositoryId': '331Xn2Ka-Od7-_68wFuUH',
		'id': 'MM4PaUbjACqaR8uQSAB2S',
		'fakeId': 'MM4PaUbjACqaR8uQSAB2S',
		'rank': 'a0'
	},
	{
		'type': 'entryPropertyString',
		'repositoryId': '331Xn2Ka-Od7-_68wFuUH',
		'propertyDefinitionId': '5tYMZ0xb7g87YKDAlZhcs',
		'slug': 'name',
		'parentId': 'MM4PaUbjACqaR8uQSAB2S',
		'value': '🐞 Bug',
		'id': 'JV4rMDhQGQbW3ibQvp-Fz',
		'fakeId': 'JV4rMDhQGQbW3ibQvp-Fz'
	},
	{
		'id': 'geg-qOCWjoSskQhNU72FS',
		'type': 'repository',
		'fakeId': 'geg-qOCWjoSskQhNU72FS',
		'parentId': null,
		'createdAt': '2026-04-26T13:12:00.455Z',
		'title': 'Item categories',
		'singular': 'Item category',
		'rank': 2,
		'color': null,
		'isBookmarked': false
	},
	{
		'id': '67ji6o1Bl7DMLFxmNw0JC',
		'type': 'templatePropertyString',
		'fakeId': '67ji6o1Bl7DMLFxmNw0JC',
		'parentId': 'geg-qOCWjoSskQhNU72FS',
		'createdAt': '2026-04-26T13:12:00.680Z',
		'label': 'Name',
		'slug': 'name',
		'required': false,
		'rank': null
	},
	{
		'type': 'repositoryEntry',
		'parentId': '9hhm_4uVcAH6Ee4MTdOPi',
		'repositoryId': '9hhm_4uVcAH6Ee4MTdOPi',
		'id': 'p5HqYsab89Fquc5w1A147',
		'fakeId': 'p5HqYsab89Fquc5w1A147',
		'rank': 'a0'
	},
	{
		'type': 'entryPropertyDate',
		'repositoryId': '9hhm_4uVcAH6Ee4MTdOPi',
		'propertyDefinitionId': 'secRcYa1ibIY_9IYlI5lj',
		'slug': 'day',
		'parentId': 'p5HqYsab89Fquc5w1A147',
		'value': '2026-04-28',
		'id': 'S7eLddU6TcNUPKPKE1DWe',
		'fakeId': 'S7eLddU6TcNUPKPKE1DWe'
	},
	{
		'type': 'entryPropertyString',
		'repositoryId': '9hhm_4uVcAH6Ee4MTdOPi',
		'propertyDefinitionId': 'kATI9Xf5DINOzNzVqu--e',
		'slug': 'goal',
		'parentId': 'p5HqYsab89Fquc5w1A147',
		'value': 'Fix bugs at list view',
		'id': '9XsDCwVVk6o0blZfC8JoE',
		'fakeId': '9XsDCwVVk6o0blZfC8JoE'
	},
	{
		'parentId': 'p5HqYsab89Fquc5w1A147',
		'repositoryId': '9hhm_4uVcAH6Ee4MTdOPi',
		'propertyDefinitionId': '5cp907OwvuNteGFgSQ-x1',
		'type': 'entryPropertyText',
		'slug': 'notes1',
		'value': '',
		'id': 'IhmMSPAX0JsFR8G2Sztm3',
		'fakeId': 'IhmMSPAX0JsFR8G2Sztm3'
	},
	{
		'type': 'templatePropertyHas',
		'label': 'Worked on',
		'slug': 'worked-on',
		'targetRepositoryId': '9hhm_4uVcAH6Ee4MTdOPi',
		'targetPropertySlug': 'work-items',
		'required': false,
		'parentId': 'aB-zKTDZjDINyCLqhgdMK',
		'rank': 4,
		'id': 'uCfkzOcAP0xYVgBhwxPF9',
		'fakeId': 'uCfkzOcAP0xYVgBhwxPF9'
	},
	{
		'type': 'repositoryEntry',
		'parentId': '331Xn2Ka-Od7-_68wFuUH',
		'repositoryId': '331Xn2Ka-Od7-_68wFuUH',
		'id': 'ImW3OpNTVFWadnV3Mh3X5',
		'fakeId': 'ImW3OpNTVFWadnV3Mh3X5',
		'rank': 'a2'
	},
	{
		'type': 'entryPropertyString',
		'repositoryId': '331Xn2Ka-Od7-_68wFuUH',
		'propertyDefinitionId': '5tYMZ0xb7g87YKDAlZhcs',
		'slug': 'name',
		'parentId': 'ImW3OpNTVFWadnV3Mh3X5',
		'value': '💎 Feature',
		'id': 'u3J7eoZ7TLulkQRsuzdP_',
		'fakeId': 'u3J7eoZ7TLulkQRsuzdP_'
	},
	{
		'type': 'repositoryEntry',
		'parentId': '331Xn2Ka-Od7-_68wFuUH',
		'repositoryId': '331Xn2Ka-Od7-_68wFuUH',
		'id': 'D0ygDBEeuwCgfN8wctWOS',
		'fakeId': 'D0ygDBEeuwCgfN8wctWOS',
		'rank': 'a3'
	},
	{
		'type': 'entryPropertyString',
		'repositoryId': '331Xn2Ka-Od7-_68wFuUH',
		'propertyDefinitionId': '5tYMZ0xb7g87YKDAlZhcs',
		'slug': 'name',
		'parentId': 'D0ygDBEeuwCgfN8wctWOS',
		'value': '✨ UX improvement',
		'id': 'gccmWs5Y0CD64W1sOesyu',
		'fakeId': 'gccmWs5Y0CD64W1sOesyu'
	},
	{
		'type': 'repositoryEntry',
		'parentId': '331Xn2Ka-Od7-_68wFuUH',
		'repositoryId': '331Xn2Ka-Od7-_68wFuUH',
		'id': 'eOzYkc1LjQmlpogD4fA4w',
		'fakeId': 'eOzYkc1LjQmlpogD4fA4w',
		'rank': 'a1'
	},
	{
		'type': 'entryPropertyString',
		'repositoryId': '331Xn2Ka-Od7-_68wFuUH',
		'propertyDefinitionId': '5tYMZ0xb7g87YKDAlZhcs',
		'slug': 'name',
		'parentId': 'eOzYkc1LjQmlpogD4fA4w',
		'value': '🪖 Chore',
		'id': 'I-cRo1HJYKWSB2g_T7ODP',
		'fakeId': 'I-cRo1HJYKWSB2g_T7ODP'
	},
	{
		'parentId': 'D0ygDBEeuwCgfN8wctWOS',
		'repositoryId': '331Xn2Ka-Od7-_68wFuUH',
		'propertyDefinitionId': 'mDkM_1ceVGEmAypsHaIXC',
		'type': 'entryPropertyString',
		'slug': 'description',
		'value': 'Adjust the look and feel of an existing user flow',
		'id': 'DdA11iSNJbc_nOySCvjX-',
		'fakeId': 'DdA11iSNJbc_nOySCvjX-'
	},
	{
		'parentId': 'MM4PaUbjACqaR8uQSAB2S',
		'repositoryId': '331Xn2Ka-Od7-_68wFuUH',
		'propertyDefinitionId': 'mDkM_1ceVGEmAypsHaIXC',
		'type': 'entryPropertyString',
		'slug': 'description',
		'value': 'Unintended product behaviour impacting end user experience',
		'id': 'rcKJ-dZmboC7pSdTXD_vx',
		'fakeId': 'rcKJ-dZmboC7pSdTXD_vx'
	},
	{
		'parentId': 'eOzYkc1LjQmlpogD4fA4w',
		'repositoryId': '331Xn2Ka-Od7-_68wFuUH',
		'propertyDefinitionId': 'mDkM_1ceVGEmAypsHaIXC',
		'type': 'entryPropertyString',
		'slug': 'description',
		'value': 'Work that pays off in the long run. Prevent UX degradation. Mitigate risks.',
		'id': 'YyedOCfC8RrtkA9gaDCrG',
		'fakeId': 'YyedOCfC8RrtkA9gaDCrG'
	},
	{
		'parentId': 'ImW3OpNTVFWadnV3Mh3X5',
		'repositoryId': '331Xn2Ka-Od7-_68wFuUH',
		'propertyDefinitionId': 'mDkM_1ceVGEmAypsHaIXC',
		'type': 'entryPropertyString',
		'slug': 'description',
		'value': 'Unlocking new user flows',
		'id': 'lNeSjLOHqLHfTp0Ih3i4a',
		'fakeId': 'lNeSjLOHqLHfTp0Ih3i4a'
	},
	{
		'type': 'repositoryEntry',
		'parentId': '331Xn2Ka-Od7-_68wFuUH',
		'repositoryId': '331Xn2Ka-Od7-_68wFuUH',
		'id': 'ZYeamVHPDew48audwhnwF',
		'fakeId': 'ZYeamVHPDew48audwhnwF',
		'rank': 'a4'
	},
	{
		'type': 'entryPropertyString',
		'repositoryId': '331Xn2Ka-Od7-_68wFuUH',
		'propertyDefinitionId': '5tYMZ0xb7g87YKDAlZhcs',
		'slug': 'name',
		'parentId': 'ZYeamVHPDew48audwhnwF',
		'value': '💡 Idea',
		'id': 'ue5DvCWJxzIRqe6d5oH3K',
		'fakeId': 'ue5DvCWJxzIRqe6d5oH3K'
	},
	{
		'parentId': 'ZYeamVHPDew48audwhnwF',
		'repositoryId': '331Xn2Ka-Od7-_68wFuUH',
		'propertyDefinitionId': 'mDkM_1ceVGEmAypsHaIXC',
		'type': 'entryPropertyString',
		'slug': 'description',
		'value': 'Needs more research',
		'id': '63XTWBhIt4NuQe5Ma_QmW',
		'fakeId': '63XTWBhIt4NuQe5Ma_QmW'
	},
	{
		'type': 'templatePropertyText',
		'label': 'Description',
		'slug': 'description',
		'required': false,
		'parentId': 'aB-zKTDZjDINyCLqhgdMK',
		'rank': 5,
		'id': 'yXP_M8uPIqErWfGQSDfyJ',
		'fakeId': 'yXP_M8uPIqErWfGQSDfyJ'
	},
	{
		'type': 'repositoryEntry',
		'parentId': 'aB-zKTDZjDINyCLqhgdMK',
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'id': '_5jm9oLpxt2WphWqscCVH',
		'fakeId': '_5jm9oLpxt2WphWqscCVH',
		'rank': 'Zy'
	},
	{
		'type': 'entryPropertyString',
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'propertyDefinitionId': '-CPX86SrlnffwRzvpNgOq',
		'slug': 'do',
		'parentId': '_5jm9oLpxt2WphWqscCVH',
		'value': 'Show total items count at list view',
		'id': 'Lit7nk0S1lw1RIlo8FD8H',
		'fakeId': 'Lit7nk0S1lw1RIlo8FD8H'
	},
	{
		'type': 'entryPropertyBelongsTo',
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'propertyDefinitionId': '4CyekONzSuI33jhX4ZNtO',
		'slug': 'type',
		'parentId': '_5jm9oLpxt2WphWqscCVH',
		'value': 'D0ygDBEeuwCgfN8wctWOS',
		'id': '0hHhTv8NeW2cYU9wFHsKr',
		'fakeId': '0hHhTv8NeW2cYU9wFHsKr',
		'targetRepositoryId': '331Xn2Ka-Od7-_68wFuUH'
	},
	{
		'type': 'entryPropertyDate',
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'propertyDefinitionId': 'WQsZN24NG0FywPKlpcHU4',
		'slug': 'created-at',
		'parentId': '_5jm9oLpxt2WphWqscCVH',
		'value': '2026-04-27',
		'id': 'Nm_Ro0rq77AS8QkeldR_y',
		'fakeId': 'Nm_Ro0rq77AS8QkeldR_y'
	},
	{
		'type': 'repositoryEntry',
		'parentId': 'aB-zKTDZjDINyCLqhgdMK',
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'id': 'ztfqf5Ld-ZqVvuUjbnMDt',
		'fakeId': 'ztfqf5Ld-ZqVvuUjbnMDt',
		'rank': 'Zw',
		'isArchived': false
	},
	{
		'type': 'entryPropertyString',
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'propertyDefinitionId': '-CPX86SrlnffwRzvpNgOq',
		'slug': 'do',
		'parentId': 'ztfqf5Ld-ZqVvuUjbnMDt',
		'value': 'Entries list can’t handle long titles on mobile',
		'id': 'hQ0f0OZOLLXHBNJx1aOgc',
		'fakeId': 'hQ0f0OZOLLXHBNJx1aOgc'
	},
	{
		'type': 'entryPropertyBelongsTo',
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'propertyDefinitionId': '4CyekONzSuI33jhX4ZNtO',
		'slug': 'type',
		'parentId': 'ztfqf5Ld-ZqVvuUjbnMDt',
		'value': 'MM4PaUbjACqaR8uQSAB2S',
		'id': 'jZDKiMx11xxwVajsKh8HD',
		'fakeId': 'jZDKiMx11xxwVajsKh8HD',
		'targetRepositoryId': '331Xn2Ka-Od7-_68wFuUH'
	},
	{
		'type': 'entryPropertyDate',
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'propertyDefinitionId': 'WQsZN24NG0FywPKlpcHU4',
		'slug': 'created-at',
		'parentId': 'ztfqf5Ld-ZqVvuUjbnMDt',
		'value': '2026-04-27',
		'id': 'LtgYHpt-AEinPu4HLnwDN',
		'fakeId': 'LtgYHpt-AEinPu4HLnwDN'
	},
	{
		'type': 'repositoryEntry',
		'parentId': 'aB-zKTDZjDINyCLqhgdMK',
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'id': 'MBOyI_S7Ci0-Kmbz_nQkI',
		'fakeId': 'MBOyI_S7Ci0-Kmbz_nQkI',
		'rank': 'Zz',
		'isArchived': false
	},
	{
		'type': 'entryPropertyString',
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'propertyDefinitionId': '-CPX86SrlnffwRzvpNgOq',
		'slug': 'do',
		'parentId': 'MBOyI_S7Ci0-Kmbz_nQkI',
		'value': 'Query builder to list view',
		'id': 'Y9am-hYtR9DNc29AXC-Zg',
		'fakeId': 'Y9am-hYtR9DNc29AXC-Zg'
	},
	{
		'type': 'entryPropertyBelongsTo',
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'propertyDefinitionId': '4CyekONzSuI33jhX4ZNtO',
		'slug': 'type',
		'parentId': 'MBOyI_S7Ci0-Kmbz_nQkI',
		'value': 'ImW3OpNTVFWadnV3Mh3X5',
		'id': 'hjFWgCl_e1jE-2YLFTT6S',
		'fakeId': 'hjFWgCl_e1jE-2YLFTT6S',
		'targetRepositoryId': '331Xn2Ka-Od7-_68wFuUH'
	},
	{
		'type': 'entryPropertyDate',
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'propertyDefinitionId': 'WQsZN24NG0FywPKlpcHU4',
		'slug': 'created-at',
		'parentId': 'MBOyI_S7Ci0-Kmbz_nQkI',
		'value': '2026-04-27',
		'id': 'IhW5nnYxinevjvPf18x_2',
		'fakeId': 'IhW5nnYxinevjvPf18x_2'
	},
	{
		'type': 'repositoryEntry',
		'parentId': 'aB-zKTDZjDINyCLqhgdMK',
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'id': 'ngMZQbo-rStZMnCnPRcxO',
		'fakeId': 'ngMZQbo-rStZMnCnPRcxO',
		'rank': 'Zv'
	},
	{
		'type': 'entryPropertyString',
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'propertyDefinitionId': '-CPX86SrlnffwRzvpNgOq',
		'slug': 'do',
		'parentId': 'ngMZQbo-rStZMnCnPRcxO',
		'value': 'Add lazy loading to the list view',
		'id': 'Q8V-7byY_At2k1sL2dtAD',
		'fakeId': 'Q8V-7byY_At2k1sL2dtAD'
	},
	{
		'type': 'entryPropertyBelongsTo',
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'propertyDefinitionId': '4CyekONzSuI33jhX4ZNtO',
		'slug': 'type',
		'parentId': 'ngMZQbo-rStZMnCnPRcxO',
		'value': 'eOzYkc1LjQmlpogD4fA4w',
		'id': 'XA2DrpT1BkbsJ_T4NliNq',
		'fakeId': 'XA2DrpT1BkbsJ_T4NliNq',
		'targetRepositoryId': '331Xn2Ka-Od7-_68wFuUH'
	},
	{
		'type': 'entryPropertyDate',
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'propertyDefinitionId': 'WQsZN24NG0FywPKlpcHU4',
		'slug': 'created-at',
		'parentId': 'ngMZQbo-rStZMnCnPRcxO',
		'value': '2026-04-27',
		'id': '6v05JS9W6LGXg11jM7nzJ',
		'fakeId': '6v05JS9W6LGXg11jM7nzJ'
	},
	{
		'type': 'repositoryEntry',
		'parentId': 'geg-qOCWjoSskQhNU72FS',
		'repositoryId': 'geg-qOCWjoSskQhNU72FS',
		'id': 'WuWAdIgZ_yFXcJaZtZkMy',
		'fakeId': 'WuWAdIgZ_yFXcJaZtZkMy',
		'rank': 'a0'
	},
	{
		'type': 'entryPropertyString',
		'repositoryId': 'geg-qOCWjoSskQhNU72FS',
		'propertyDefinitionId': '67ji6o1Bl7DMLFxmNw0JC',
		'slug': 'name',
		'parentId': 'WuWAdIgZ_yFXcJaZtZkMy',
		'value': 'Collection list view',
		'id': 'k0zJjvxvFgGttR1srUi4p',
		'fakeId': 'k0zJjvxvFgGttR1srUi4p'
	},
	{
		'parentId': 'ngMZQbo-rStZMnCnPRcxO',
		'type': 'entryPropertyBelongsTo',
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'propertyDefinitionId': 'n6umKbiRaVdZmeovJhd2A',
		'targetRepositoryId': 'geg-qOCWjoSskQhNU72FS',
		'slug': 'category',
		'value': 'WuWAdIgZ_yFXcJaZtZkMy',
		'id': 'tuAFWHqPJ50Kk8mKSfhon',
		'fakeId': 'tuAFWHqPJ50Kk8mKSfhon'
	},
	{
		'parentId': '_5jm9oLpxt2WphWqscCVH',
		'type': 'entryPropertyBelongsTo',
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'propertyDefinitionId': 'n6umKbiRaVdZmeovJhd2A',
		'targetRepositoryId': 'geg-qOCWjoSskQhNU72FS',
		'slug': 'category',
		'value': 'WuWAdIgZ_yFXcJaZtZkMy',
		'id': 'JKtZTO2YOx7RXgjaH6mDU',
		'fakeId': 'JKtZTO2YOx7RXgjaH6mDU'
	},
	{
		'type': 'templatePropertyDate',
		'label': 'Shipped date',
		'slug': 'shipped-date',
		'required': false,
		'parentId': 'aB-zKTDZjDINyCLqhgdMK',
		'rank': 7,
		'id': 'WXumQcFO_lv8E73Pwy8Ri',
		'fakeId': 'WXumQcFO_lv8E73Pwy8Ri'
	},
	{
		'parentId': 'ztfqf5Ld-ZqVvuUjbnMDt',
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'propertyDefinitionId': 'WXumQcFO_lv8E73Pwy8Ri',
		'type': 'entryPropertyDate',
		'slug': 'shipped-date',
		'value': '2026-05-01',
		'id': 'PSZOOxWvhwc65HS2GG7hm',
		'fakeId': 'PSZOOxWvhwc65HS2GG7hm'
	},
	{
		'parentId': 'MBOyI_S7Ci0-Kmbz_nQkI',
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'propertyDefinitionId': 'WXumQcFO_lv8E73Pwy8Ri',
		'type': 'entryPropertyDate',
		'slug': 'shipped-date',
		'value': '2026-04-29',
		'id': 'QoX4YXiufG5TXdbkQ37JL',
		'fakeId': 'QoX4YXiufG5TXdbkQ37JL'
	},
	{
		'parentId': '_5jm9oLpxt2WphWqscCVH',
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'propertyDefinitionId': 'WXumQcFO_lv8E73Pwy8Ri',
		'type': 'entryPropertyDate',
		'slug': 'shipped-date',
		'value': '2026-04-30',
		'id': 'a0Iul8wNCX8phkVMRC9Ez',
		'fakeId': 'a0Iul8wNCX8phkVMRC9Ez'
	},
	{
		'parentId': 'p5HqYsab89Fquc5w1A147',
		'type': 'entryPropertyBelongsTo',
		'repositoryId': '9hhm_4uVcAH6Ee4MTdOPi',
		'propertyDefinitionId': 'uCfkzOcAP0xYVgBhwxPF9',
		'targetRepositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'slug': 'work-items',
		'value': 'ztfqf5Ld-ZqVvuUjbnMDt',
		'id': 'pbnjAAUjqao6iP7pSF4q1',
		'fakeId': 'pbnjAAUjqao6iP7pSF4q1'
	},
	{
		'type': 'repositoryEntry',
		'parentId': '9hhm_4uVcAH6Ee4MTdOPi',
		'repositoryId': '9hhm_4uVcAH6Ee4MTdOPi',
		'id': 't7wW3vx0JTd1nb_7PLSXY',
		'fakeId': 't7wW3vx0JTd1nb_7PLSXY',
		'rank': 'Zz'
	},
	{
		'type': 'entryPropertyDate',
		'repositoryId': '9hhm_4uVcAH6Ee4MTdOPi',
		'propertyDefinitionId': 'secRcYa1ibIY_9IYlI5lj',
		'slug': 'day',
		'parentId': 't7wW3vx0JTd1nb_7PLSXY',
		'value': '2026-04-27',
		'id': 'tfuIci96SbOvRfGMVUUkJ',
		'fakeId': 'tfuIci96SbOvRfGMVUUkJ'
	},
	{
		'type': 'entryPropertyString',
		'repositoryId': '9hhm_4uVcAH6Ee4MTdOPi',
		'propertyDefinitionId': 'kATI9Xf5DINOzNzVqu--e',
		'slug': 'goal',
		'parentId': 't7wW3vx0JTd1nb_7PLSXY',
		'value': 'Ship query builder',
		'id': 'VqWVdkucpLGo6Un-b8vV-',
		'fakeId': 'VqWVdkucpLGo6Un-b8vV-'
	},
	{
		'parentId': 't7wW3vx0JTd1nb_7PLSXY',
		'type': 'entryPropertyBelongsTo',
		'repositoryId': '9hhm_4uVcAH6Ee4MTdOPi',
		'propertyDefinitionId': 'uCfkzOcAP0xYVgBhwxPF9',
		'targetRepositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'slug': 'work-items',
		'value': 'MBOyI_S7Ci0-Kmbz_nQkI',
		'id': 'dQkeHvTtD_zr9SOhuYnDx',
		'fakeId': 'dQkeHvTtD_zr9SOhuYnDx'
	},
	{
		'parentId': 't7wW3vx0JTd1nb_7PLSXY',
		'type': 'entryPropertyBelongsTo',
		'repositoryId': '9hhm_4uVcAH6Ee4MTdOPi',
		'propertyDefinitionId': 'uCfkzOcAP0xYVgBhwxPF9',
		'targetRepositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'slug': 'work-items',
		'value': '_5jm9oLpxt2WphWqscCVH',
		'id': 'rh2iaXl-Wed3YSb_BnaAF',
		'fakeId': 'rh2iaXl-Wed3YSb_BnaAF'
	},
	{
		'parentId': 'ztfqf5Ld-ZqVvuUjbnMDt',
		'type': 'entryPropertyBelongsTo',
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'propertyDefinitionId': 'n6umKbiRaVdZmeovJhd2A',
		'targetRepositoryId': 'geg-qOCWjoSskQhNU72FS',
		'slug': 'category',
		'value': 'WuWAdIgZ_yFXcJaZtZkMy',
		'id': 'gK8P9JamBxRIvOh-z7JsW',
		'fakeId': 'gK8P9JamBxRIvOh-z7JsW'
	},
	{
		'type': 'repository',
		'title': 'Item statuses',
		'singular': 'Item status',
		'parentId': null,
		'rank': 1,
		'id': 'N02szigG-O17-95Jteb96',
		'fakeId': 'N02szigG-O17-95Jteb96',
		'isBookmarked': false,
		'color': null
	},
	{
		'type': 'templatePropertyString',
		'parentId': 'N02szigG-O17-95Jteb96',
		'label': 'Name',
		'slug': 'name',
		'required': false,
		'id': 'k4jBDF-2DGG1ceVIJwk2P',
		'fakeId': 'k4jBDF-2DGG1ceVIJwk2P'
	},
	{
		'type': 'repositoryEntry',
		'parentId': 'N02szigG-O17-95Jteb96',
		'repositoryId': 'N02szigG-O17-95Jteb96',
		'id': 'YMBl2E7D_xoG1Q8L8nNAr',
		'fakeId': 'YMBl2E7D_xoG1Q8L8nNAr',
		'rank': 'a0'
	},
	{
		'type': 'entryPropertyString',
		'repositoryId': 'N02szigG-O17-95Jteb96',
		'propertyDefinitionId': 'k4jBDF-2DGG1ceVIJwk2P',
		'slug': 'name',
		'parentId': 'YMBl2E7D_xoG1Q8L8nNAr',
		'value': 'Selected for development',
		'id': 'qZW1ZEJdUXoC9SBWTuaph',
		'fakeId': 'qZW1ZEJdUXoC9SBWTuaph'
	},
	{
		'type': 'repositoryEntry',
		'parentId': 'N02szigG-O17-95Jteb96',
		'repositoryId': 'N02szigG-O17-95Jteb96',
		'id': '9LgNgPAaMh8GwgBtgdK-N',
		'fakeId': '9LgNgPAaMh8GwgBtgdK-N',
		'rank': 'Zz'
	},
	{
		'type': 'entryPropertyString',
		'repositoryId': 'N02szigG-O17-95Jteb96',
		'propertyDefinitionId': 'k4jBDF-2DGG1ceVIJwk2P',
		'slug': 'name',
		'parentId': '9LgNgPAaMh8GwgBtgdK-N',
		'value': 'In progress',
		'id': 'kcA0ZGhyBKRqntD8fDCnE',
		'fakeId': 'kcA0ZGhyBKRqntD8fDCnE'
	},
	{
		'type': 'repositoryEntry',
		'parentId': 'N02szigG-O17-95Jteb96',
		'repositoryId': 'N02szigG-O17-95Jteb96',
		'id': 'K_bddKrFCcOLwqnauFBox',
		'fakeId': 'K_bddKrFCcOLwqnauFBox',
		'rank': 'Zy'
	},
	{
		'type': 'entryPropertyString',
		'repositoryId': 'N02szigG-O17-95Jteb96',
		'propertyDefinitionId': 'k4jBDF-2DGG1ceVIJwk2P',
		'slug': 'name',
		'parentId': 'K_bddKrFCcOLwqnauFBox',
		'value': 'Done',
		'id': 'JtotqaGIk5x3ER7XbmDzU',
		'fakeId': 'JtotqaGIk5x3ER7XbmDzU'
	},
	{
		'type': 'templatePropertyBelongsTo',
		'label': 'Status',
		'slug': 'status',
		'targetRepositoryId': 'N02szigG-O17-95Jteb96',
		'required': false,
		'allowMany': false,
		'parentId': 'aB-zKTDZjDINyCLqhgdMK',
		'rank': 3,
		'id': '5CQlkZGxqVtmE_pGFQd8X',
		'fakeId': '5CQlkZGxqVtmE_pGFQd8X'
	},
	{
		'type': 'resource',
		'parentId': null,
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'repositoryEntryId': '_5jm9oLpxt2WphWqscCVH',
		'xy': {
			'x': 8.362356846985222,
			'y': -133.66480000657634
		},
		'id': 'zFv4ZwTxP2lcy3-N_rvPr',
		'fakeId': 'zFv4ZwTxP2lcy3-N_rvPr'
	},
	{
		'type': 'resource',
		'parentId': null,
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'repositoryEntryId': 'ztfqf5Ld-ZqVvuUjbnMDt',
		'xy': {
			'x': -338.04017315685417,
			'y': -121.16493431381649
		},
		'id': 's92HMI7Bo4qZjrrKWGYQH',
		'fakeId': 's92HMI7Bo4qZjrrKWGYQH'
	},
	{
		'type': 'resource',
		'parentId': null,
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'repositoryEntryId': 'MBOyI_S7Ci0-Kmbz_nQkI',
		'xy': {
			'x': -338.04017315685417,
			'y': 398.0199665769975
		},
		'id': 'cL3rLKVMq4BjLOILL-7P-',
		'fakeId': 'cL3rLKVMq4BjLOILL-7P-'
	},
	{
		'type': 'resource',
		'parentId': null,
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'repositoryEntryId': 'ngMZQbo-rStZMnCnPRcxO',
		'xy': {
			'x': -338.04017315685417,
			'y': 146.49993078047711
		},
		'id': 'XanJEThpa4RwjIkatArx2',
		'fakeId': 'XanJEThpa4RwjIkatArx2'
	},
	{
		'type': 'grid',
		'parentId': null,
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'primaryPropertyId': '5CQlkZGxqVtmE_pGFQd8X',
		'secondaryPropertyId': null,
		'direction': 'vertical',
		'xy': {
			'x': -611.2254617787072,
			'y': -314.96601251777525
		},
		'id': 'wwqlvaglzwPuE0O_sNrYn',
		'fakeId': 'wwqlvaglzwPuE0O_sNrYn'
	},
	{
		'type': 'resource',
		'parentId': null,
		'repositoryId': 'N02szigG-O17-95Jteb96',
		'repositoryEntryId': 'YMBl2E7D_xoG1Q8L8nNAr',
		'xy': {
			'x': -338.04017315685417,
			'y': -314.96601251777525
		},
		'id': 'NeBaHE7I29gE1aqoIevC3',
		'fakeId': 'NeBaHE7I29gE1aqoIevC3'
	},
	{
		'type': 'resource',
		'parentId': null,
		'repositoryId': 'N02szigG-O17-95Jteb96',
		'repositoryEntryId': '9LgNgPAaMh8GwgBtgdK-N',
		'xy': {
			'x': 8.362356846985222,
			'y': -314.96601251777525
		},
		'id': 'fV5k_jSyiKGKLFlw9FTWW',
		'fakeId': 'fV5k_jSyiKGKLFlw9FTWW'
	},
	{
		'type': 'resource',
		'parentId': null,
		'repositoryId': 'N02szigG-O17-95Jteb96',
		'repositoryEntryId': 'K_bddKrFCcOLwqnauFBox',
		'xy': {
			'x': 334.9038970801548,
			'y': -314.96601251777525
		},
		'id': 'jO2caSLWnMlqgZ_w1fTzu',
		'fakeId': 'jO2caSLWnMlqgZ_w1fTzu'
	},
	{
		'parentId': 'MBOyI_S7Ci0-Kmbz_nQkI',
		'type': 'entryPropertyBelongsTo',
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'propertyDefinitionId': '5CQlkZGxqVtmE_pGFQd8X',
		'targetRepositoryId': 'N02szigG-O17-95Jteb96',
		'slug': 'status',
		'value': 'YMBl2E7D_xoG1Q8L8nNAr',
		'id': 'mCkSJjB_D21vNyDE-pc99',
		'fakeId': 'mCkSJjB_D21vNyDE-pc99'
	},
	{
		'parentId': 'ngMZQbo-rStZMnCnPRcxO',
		'type': 'entryPropertyBelongsTo',
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'propertyDefinitionId': '5CQlkZGxqVtmE_pGFQd8X',
		'targetRepositoryId': 'N02szigG-O17-95Jteb96',
		'slug': 'status',
		'value': 'YMBl2E7D_xoG1Q8L8nNAr',
		'id': 'o5X4rUSdZycuxlH7zQFkC',
		'fakeId': 'o5X4rUSdZycuxlH7zQFkC'
	},
	{
		'parentId': 'ztfqf5Ld-ZqVvuUjbnMDt',
		'type': 'entryPropertyBelongsTo',
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'propertyDefinitionId': '5CQlkZGxqVtmE_pGFQd8X',
		'targetRepositoryId': 'N02szigG-O17-95Jteb96',
		'slug': 'status',
		'value': 'YMBl2E7D_xoG1Q8L8nNAr',
		'id': 'pGS4yGcna3-Tpewu7f1OH',
		'fakeId': 'pGS4yGcna3-Tpewu7f1OH'
	},
	{
		'type': 'repository',
		'title': 'Team members',
		'singular': 'Team member',
		'parentId': null,
		'rank': 1,
		'id': 'v-T7NQeeusiUmd_KGtrXz',
		'fakeId': 'v-T7NQeeusiUmd_KGtrXz',
		'isBookmarked': false,
		'color': null
	},
	{
		'type': 'templatePropertyString',
		'parentId': 'v-T7NQeeusiUmd_KGtrXz',
		'label': 'Name',
		'slug': 'name',
		'required': false,
		'id': 'nOjxvbkdIXjBzNjR-nbNL',
		'fakeId': 'nOjxvbkdIXjBzNjR-nbNL'
	},
	{
		'type': 'repositoryEntry',
		'parentId': 'v-T7NQeeusiUmd_KGtrXz',
		'repositoryId': 'v-T7NQeeusiUmd_KGtrXz',
		'id': '2znZrG8rFkCmUtWOgvIJu',
		'fakeId': '2znZrG8rFkCmUtWOgvIJu',
		'rank': 'a0'
	},
	{
		'parentId': '2znZrG8rFkCmUtWOgvIJu',
		'repositoryId': 'v-T7NQeeusiUmd_KGtrXz',
		'propertyDefinitionId': 'nOjxvbkdIXjBzNjR-nbNL',
		'type': 'entryPropertyString',
		'slug': 'name',
		'value': 'Liam',
		'id': 'QxYv3u1McVc46aAWYcvog',
		'fakeId': 'QxYv3u1McVc46aAWYcvog'
	},
	{
		'type': 'repositoryEntry',
		'parentId': 'v-T7NQeeusiUmd_KGtrXz',
		'repositoryId': 'v-T7NQeeusiUmd_KGtrXz',
		'id': 'mQuh9fK_GbmGptZeXLZ1V',
		'fakeId': 'mQuh9fK_GbmGptZeXLZ1V',
		'rank': 'Zz'
	},
	{
		'type': 'entryPropertyString',
		'repositoryId': 'v-T7NQeeusiUmd_KGtrXz',
		'propertyDefinitionId': 'nOjxvbkdIXjBzNjR-nbNL',
		'slug': 'name',
		'parentId': 'mQuh9fK_GbmGptZeXLZ1V',
		'value': 'Marcus',
		'id': 'uVIMt0nXOvt8DSHuzkzX3',
		'fakeId': 'uVIMt0nXOvt8DSHuzkzX3'
	},
	{
		'type': 'repositoryEntry',
		'parentId': 'v-T7NQeeusiUmd_KGtrXz',
		'repositoryId': 'v-T7NQeeusiUmd_KGtrXz',
		'id': '9Qvd-Q4dsARRJ16-quLIr',
		'fakeId': '9Qvd-Q4dsARRJ16-quLIr',
		'rank': 'Zy'
	},
	{
		'type': 'entryPropertyString',
		'repositoryId': 'v-T7NQeeusiUmd_KGtrXz',
		'propertyDefinitionId': 'nOjxvbkdIXjBzNjR-nbNL',
		'slug': 'name',
		'parentId': '9Qvd-Q4dsARRJ16-quLIr',
		'value': 'Elena',
		'id': '91BuRnh9eKCACiCSIwfWy',
		'fakeId': '91BuRnh9eKCACiCSIwfWy'
	},
	{
		'type': 'templatePropertyBelongsTo',
		'label': 'Assigned to',
		'slug': 'assigned-to',
		'targetRepositoryId': 'v-T7NQeeusiUmd_KGtrXz',
		'required': false,
		'allowMany': false,
		'parentId': 'aB-zKTDZjDINyCLqhgdMK',
		'rank': 2,
		'id': 'JU0d7ek5n6znb4uu35DF4',
		'fakeId': 'JU0d7ek5n6znb4uu35DF4'
	},
	{
		'parentId': '_5jm9oLpxt2WphWqscCVH',
		'type': 'entryPropertyBelongsTo',
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'propertyDefinitionId': '5CQlkZGxqVtmE_pGFQd8X',
		'targetRepositoryId': 'N02szigG-O17-95Jteb96',
		'slug': 'status',
		'value': '9LgNgPAaMh8GwgBtgdK-N',
		'id': 'pNXblP37uwR7MMGoHdwTb',
		'fakeId': 'pNXblP37uwR7MMGoHdwTb'
	},
	{
		'parentId': 'ztfqf5Ld-ZqVvuUjbnMDt',
		'type': 'entryPropertyBelongsTo',
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'propertyDefinitionId': 'JU0d7ek5n6znb4uu35DF4',
		'targetRepositoryId': 'v-T7NQeeusiUmd_KGtrXz',
		'slug': 'assigned-to',
		'value': 'mQuh9fK_GbmGptZeXLZ1V',
		'id': 'P808nkPjE10UUpPaNlGWO',
		'fakeId': 'P808nkPjE10UUpPaNlGWO'
	},
	{
		'parentId': 'ngMZQbo-rStZMnCnPRcxO',
		'type': 'entryPropertyBelongsTo',
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'propertyDefinitionId': 'JU0d7ek5n6znb4uu35DF4',
		'targetRepositoryId': 'v-T7NQeeusiUmd_KGtrXz',
		'slug': 'assigned-to',
		'value': '2znZrG8rFkCmUtWOgvIJu',
		'id': 'ZfVnoGu19CHbu0Md93RBK',
		'fakeId': 'ZfVnoGu19CHbu0Md93RBK'
	},
	{
		'parentId': 'MBOyI_S7Ci0-Kmbz_nQkI',
		'type': 'entryPropertyBelongsTo',
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'propertyDefinitionId': 'JU0d7ek5n6znb4uu35DF4',
		'targetRepositoryId': 'v-T7NQeeusiUmd_KGtrXz',
		'slug': 'assigned-to',
		'value': '9Qvd-Q4dsARRJ16-quLIr',
		'id': 'LORNp3635_MM8KJRM2Hk3',
		'fakeId': 'LORNp3635_MM8KJRM2Hk3'
	},
	{
		'parentId': '_5jm9oLpxt2WphWqscCVH',
		'type': 'entryPropertyBelongsTo',
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'propertyDefinitionId': 'JU0d7ek5n6znb4uu35DF4',
		'targetRepositoryId': 'v-T7NQeeusiUmd_KGtrXz',
		'slug': 'assigned-to',
		'value': '2znZrG8rFkCmUtWOgvIJu',
		'id': '2Y7eqRrGNIgfoglu4kjYs',
		'fakeId': '2Y7eqRrGNIgfoglu4kjYs'
	},
	{
		'type': 'note',
		'title': 'This is your planning view — here you can place notes, data references and other elements that help you organize your data.  🤗',
		'parentId': null,
		'rank': 8,
		'xy': {
			'x': -896.3950109649132,
			'y': -545.433662280702
		},
		'id': 'Nat8Xe0iiYq3AQvyZs0Rz',
		'fakeId': 'Nat8Xe0iiYq3AQvyZs0Rz'
	},
	{
		'type': 'note',
		'title': 'You can even place notes within notes, and navigate through them...',
		'parentId': null,
		'rank': 9,
		'xy': {
			'x': -831.4903722574002,
			'y': -452.41418741196316
		},
		'id': 'DjouND17wW_1V14cpBLUp',
		'fakeId': 'DjouND17wW_1V14cpBLUp'
	}
];